import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import EmployeeCredentials from '../admin/employees/employeeCredentials';
const PasswordExpiredModal = props => {
  const {
    onSave,
    rules
  } = props;
  const [value, setValue] = useState('');
  const handleChange = (field, newValue) => setValue(newValue);
  const handleSave = () => onSave(value);
  const disabled = !(rules.length && rules.upper && rules.lower && rules.symbol);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: true
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement("div", {
    className: "h2"
  }, "Password Reset"), /*#__PURE__*/React.createElement("div", {
    className: "h4"
  }, "Your password has expired. Please enter a new one here.")), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(EmployeeCredentials, {
    showOnlyPassword: true,
    password: value,
    onChange: handleChange,
    onSave: handleSave
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSave,
    disabled: disabled
  }, "Set New Password")));
};
PasswordExpiredModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  rules: PropTypes.shape({
    length: PropTypes.bool,
    upper: PropTypes.bool,
    lower: PropTypes.bool,
    symbol: PropTypes.bool
  }).isRequired
};
export default PasswordExpiredModal;